import React, { useState, useEffect } from "react";
import Base from "../../Config/Base";
import { Link, useLocation } from "react-router-dom";
import { API_BASE_CRM_URL } from "../../Config/Config";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "../../Config/swal.css";
import { Tabs, Input, Checkbox, Button, Row, Col, Select, Spin } from "antd";
import { Footer } from "../footer/footer";
const { TextArea } = Input;
const iconStyle = {
  color: "#999",
  width: "16px",
};

export default function AddCustomer() {
  const navigate = useNavigate();
  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");
    if (!userDetails) {
      navigate("/");
    }
  }, [navigate]);
  const [userDetails, SetUserDetails] = useState([]);
  const location = useLocation();
  const leadData = location.state?.lead || {};
  const [sameAddress, setSameAddress] = useState(false);
  const [activeTab, setActiveTab] = useState("info");

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  useEffect(() => {
    const userDetailsSession = JSON.parse(
      sessionStorage.getItem("userDetails"),
    );
    SetUserDetails(userDetailsSession);
  }, []);

  const [selectedproductid, setselectedproductid] = useState("");
  const [formData, setFormData] = useState({
    company: "",
    phonenumber: "",
    country: 1,
    zip: "",
    city: "",
    state: "",
    Address: "",
    website: "",
    leadid: "",
    addedfrom: 1,
    active: 1,
    firstName: "",
    lastName: "",
    title: "",
    email: "",
    billing_street: "",
    billing_city: "",
    billing_state: "",
    billing_zip: "",
    shipping_street: "",
    shipping_city: "",
    shipping_state: "",
    shipping_zip: "",
  });
  const [loading, setLoading] = useState(false);

  // Seed formData from leadData ONCE when arriving via "Convert to Customer".
  // From here on, formData is the single source of truth for every field,
  // so typing in any input actually updates what's displayed.
  useEffect(() => {
    if (leadData && Object.keys(leadData).length > 0) {
      setFormData((prev) => ({
        ...prev,
        company: leadData.company || prev.company,
        website:
          leadData.website && leadData.website !== "null"
            ? leadData.website
            : prev.website,
        city: leadData.city || prev.city,
        state:
          leadData.state && leadData.state !== "null"
            ? leadData.state
            : prev.state,
        zip: leadData.zip && leadData.zip !== "null" ? leadData.zip : prev.zip,
        Address: leadData.address || leadData.Address || prev.Address,
        firstName: leadData.name || prev.firstName,
        phonenumber: leadData.phonenumber || prev.phonenumber,
        email: leadData.email || prev.email,
        leadid: leadData.id || leadData.leadid || prev.leadid,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleProductChange = (selectedOption) => {
    setselectedproductid(selectedOption);
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    setLoading(true);

    const payload = {
      company: formData.company,
      phonenumber: formData.phonenumber,
      country: formData.country || 1,
      city: formData.city,
      state: formData.state,
      zip: formData.zip,
      address: formData.Address,
      website: formData.website,
      leadid: formData.leadid || leadData?.id || 0,
      addedfrom: userDetails.staffid,
      active: 1,

      billing_street: formData.billing_street,
      billing_city: formData.billing_city,
      billing_state: formData.billing_state,
      billing_zip: formData.billing_zip,

      shipping_street: formData.shipping_street,
      shipping_city: formData.shipping_city,
      shipping_state: formData.shipping_state,
      shipping_zip: formData.shipping_zip,
    };

    try {
      // Step 1: Add Customer
      const response = await fetch(`${API_BASE_CRM_URL}customers/AddCustomer`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorResponse = await response.text();
        console.error("Server Error:", errorResponse);
        throw new Error(`Network response was not ok: ${response.status}`);
      }

      const result = await response.json();

      if (result.Status) {
        const contactData = {
          userid: result.clientId,
          firstname: formData.firstName,
          lastname: formData.lastName,
          email: formData.email,
          phonenumber: formData.phonenumber,
          title: formData.title,
          is_primary: 1,
          active: 1,
        };

        const contactResponse = await fetch(
          `${API_BASE_CRM_URL}customers/AddContact`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(contactData),
          },
        );

        const contactResult = await contactResponse.json();

        if (contactResult.Status) {
          Swal.fire({
            title: "Customer Added Successfully.",
            icon: "success",
            customClass: {
              title: "swal-title",
              content: "swal-text",
            },
          }).then((swalResult) => {
            if (swalResult.isConfirmed || swalResult.isDismissed) {
              navigate("/customers");
            }
          });
        } else {
          Swal.fire({
            title: "Error",
            text: "Customer added but contact creation failed.",
            icon: "error",
          });
        }
      } else {
        Swal.fire({
          title: "Error",
          text: "Failed to submit customer request.",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        title: "Error",
        text: "An error occurred while submitting the request.",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSameAddress = (checked) => {
    setSameAddress(checked);

    if (checked) {
      setFormData((prev) => ({
        ...prev,
        shipping_street: prev.billing_street,
        shipping_city: prev.billing_city,
        shipping_state: prev.billing_state,
        shipping_zip: prev.billing_zip,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        shipping_street: "",
        shipping_city: "",
        shipping_state: "",
        shipping_zip: "",
      }));
    }
  };

  const tabItems = [
    {
      key: "info",
      label: (
        <span>
          <i className="fa-regular fa-address-book me-2"></i>
          Info
        </span>
      ),
      children: (
        <>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12} lg={8}>
              <Input
                size="large"
                prefix={
                  <i className="fa-solid fa-building" style={iconStyle} />
                }
                name="company"
                value={formData.company || ""}
                placeholder="Organization name"
                onChange={handleChange}
              />
            </Col>

            <Col xs={24} md={12} lg={8}>
              <Input
                size="large"
                prefix={<i className="fa-solid fa-globe" style={iconStyle} />}
                name="website"
                value={formData.website || ""}
                placeholder="Website"
                onChange={handleChange}
              />
            </Col>

            <Col xs={12} md={12} lg={8}>
              <Input
                size="large"
                prefix={<i className="fa-solid fa-city" style={iconStyle} />}
                name="city"
                value={formData.city || ""}
                placeholder="City"
                onChange={handleChange}
              />
            </Col>

            <Col xs={12} md={12} lg={8}>
              <Input
                size="large"
                prefix={<i className="fa-solid fa-map" style={iconStyle} />}
                name="state"
                value={formData.state || ""}
                placeholder="State"
                onChange={handleChange}
              />
            </Col>

            <Col xs={12} md={12} lg={8}>
              <Input
                size="large"
                prefix={
                  <i className="fa-solid fa-location-dot" style={iconStyle} />
                }
                name="zip"
                value={formData.zip || ""}
                placeholder="Zipcode"
                onChange={handleChange}
              />
            </Col>

            <Col xs={24} md={12} lg={8}>
              <TextArea
                name="Address"
                rows={3}
                value={formData.Address || ""}
                placeholder="Address"
                onChange={handleChange}
              />
            </Col>
          </Row>

          <hr />

          <h5 className="mb-3">Contact Person</h5>

          <Row gutter={[16, 16]}>
            <Col xs={12} md={12} lg={8}>
              <Input
                size="large"
                prefix={<i className="fa-solid fa-user" style={iconStyle} />}
                name="firstName"
                value={formData.firstName || ""}
                placeholder=" First name"
                onChange={handleChange}
              />
            </Col>

            <Col xs={12} md={12} lg={8}>
              <Input
                size="large"
                prefix={<i className="fa-solid fa-user" style={iconStyle} />}
                name="lastName"
                value={formData.lastName || ""}
                placeholder=" last name"
                onChange={handleChange}
              />
            </Col>

            <Col xs={12} md={12} lg={8}>
              <Input
                size="large"
                prefix={<i className="fa-solid fa-phone" style={iconStyle} />}
                name="phonenumber"
                value={formData.phonenumber || ""}
                placeholder=" phone number"
                onChange={handleChange}
              />
            </Col>

            <Col xs={12} md={12} lg={8}>
              <Input
                size="large"
                prefix={
                  <i className="fa-solid fa-id-badge" style={iconStyle} />
                }
                name="title"
                value={formData.title || ""}
                placeholder="Title"
                onChange={handleChange}
              />
            </Col>
            <Col xs={24} md={12} lg={8}>
              <Input
                size="large"
                prefix={
                  <i className="fa-solid fa-envelope" style={iconStyle} />
                }
                name="email"
                value={formData.email || ""}
                placeholder="Email"
                onChange={handleChange}
              />
            </Col>
          </Row>
        </>
      ),
    },

    {
      key: "address",
      label: (
        <span>
          <i className="fa-solid fa-map-location-dot me-2"></i>
          Billing & Shipping Address
        </span>
      ),
      children: (
        <>
          <h5 className="mb-3">Billing Address</h5>

          <Row gutter={[16, 16]}>
            <Col xs={24} md={12} lg={8}>
              <Input
                size="large"
                prefix={<i className="fa-solid fa-road" />}
                name="billing_street"
                value={formData.billing_street}
                placeholder="Billing Street"
                onChange={handleChange}
              />
            </Col>

            <Col xs={24} md={12} lg={8}>
              <Input
                size="large"
                prefix={<i className="fa-solid fa-city" />}
                name="billing_city"
                value={formData.billing_city}
                placeholder="Billing City"
                onChange={handleChange}
              />
            </Col>

            <Col xs={24} md={12} lg={8}>
              <Input
                size="large"
                prefix={<i className="fa-solid fa-map" />}
                name="billing_state"
                value={formData.billing_state}
                placeholder="Billing State"
                onChange={handleChange}
              />
            </Col>

            <Col xs={24} md={12} lg={8}>
              <Input
                size="large"
                prefix={<i className="fa-solid fa-location-dot" />}
                name="billing_zip"
                value={formData.billing_zip}
                placeholder="Billing Zipcode"
                onChange={handleChange}
              />
            </Col>
          </Row>

          <div className="my-4">
            <Checkbox
              checked={sameAddress}
              onChange={(e) => handleSameAddress(e.target.checked)}
            >
              Shipping address is same as Billing address
            </Checkbox>
          </div>

          <h5 className="mb-3">Shipping Address</h5>

          <Row gutter={[16, 16]}>
            <Col xs={24} md={12} lg={8}>
              <Input
                size="large"
                prefix={<i className="fa-solid fa-road" />}
                name="shipping_street"
                value={formData.shipping_street}
                placeholder="Shipping Street"
                onChange={handleChange}
                disabled={sameAddress}
              />
            </Col>

            <Col xs={24} md={12} lg={8}>
              <Input
                size="large"
                prefix={<i className="fa-solid fa-city" />}
                name="shipping_city"
                value={formData.shipping_city}
                placeholder="Shipping City"
                onChange={handleChange}
                disabled={sameAddress}
              />
            </Col>

            <Col xs={24} md={12} lg={8}>
              <Input
                size="large"
                prefix={<i className="fa-solid fa-map" />}
                name="shipping_state"
                value={formData.shipping_state}
                placeholder="Shipping State"
                onChange={handleChange}
                disabled={sameAddress}
              />
            </Col>

            <Col xs={24} md={12} lg={8}>
              <Input
                size="large"
                prefix={<i className="fa-solid fa-location-dot" />}
                name="shipping_zip"
                value={formData.shipping_zip}
                placeholder="Shipping Zipcode"
                onChange={handleChange}
                disabled={sameAddress}
              />
            </Col>
          </Row>
        </>
      ),
    },
  ];

  return (
    <Base>
      {loading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div className="page-heade mb-3">
        <div className="row align-items-center">
          <div className="col-10">
            <div className="page-title">
              <h4>Add customer</h4>
              <p className="fw-semibold">
                Fill out the form to add a new customer
              </p>
            </div>
          </div>
          <div className="col-2 d-flex justify-content-end ">
            <Link to="/customers">
              <button className="btn btn-secondary btn-sm">
                <i className="fa-solid fa-list"></i>
              </button>
            </Link>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <Tabs
              activeKey={activeTab}
              onChange={handleTabChange}
              items={tabItems}
              type="card"
              size="large"
            />
            {activeTab === "info" && (
              <div className="d-flex justify-content-end mt-2">
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={() => setActiveTab("address")}
                  type="button"
                >
                  Next
                </button>
              </div>
            )}
            {activeTab === "address" && (
              <div className="d-flex justify-content-between mt-3">
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={() => setActiveTab("info")}
                  type="button"
                >
                  Previous
                </button>
                <button
                  className="btn btn-sm btn-primary"
                  type="submit"
                  loading={loading}
                >
                  Submit
                </button>
              </div>
            )}
          </form>
        </div>
      </div>
      <Footer />
    </Base>
  );
}
